
  import React from "react"
  import Component from "/app/src/layouts/index.js"
  import data from "/app/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js